import { QueryClientProvider } from 'react-query';
import { queryClient } from 'src/api/queryClient';
import 'src/frames/components/index.scss';
import { cn } from 'src/frames/utils/cn';
import { SelfTestStateProvider, SelfTestView } from 'src/selfTest/components';
import './App.scss';
import {getUrlParam} from "../../utils/getUrlParam";

window.eventsQueue = window.eventsQueue || [];

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <div className={cn('App', 'flex flex-col', 'mx-auto', getUrlParam('theme'))}>
        <SelfTestStateProvider>
          <SelfTestView className="flex-1" />
        </SelfTestStateProvider>
      </div>
    </QueryClientProvider>
  );
}
